module.exports = __webpack_public_path__ + "img/标准文件5.7bfb43f7.png";